import { useState, useEffect } from 'react';
import './NewsPage.css';
import logo from '../../assets/images/rocaille-logo.png';
import { usePosts } from '../Aktuelles/posts';
import PostCard from '../Aktuelles/PostCard';
import LegalModal from '../LegalModal/LegalModal';
import Footer from '../Footer/Footer';

function NewsPage() {
  const [legalModal, setLegalModal] = useState(null);
  const posts = usePosts();

  useEffect(() => {
    document.title = 'Neuigkeiten – Rocaille Düsseldorf';
  }, []);

  return (
    <div className="news">
      {legalModal && (
        <LegalModal type={legalModal} onClose={() => setLegalModal(null)} />
      )}

      <header className="news__topbar">
        <a href="/" className="news__home">
          <img src={logo} alt="Rocaille" className="news__logo" />
        </a>
        <a href="/#aktuelles" className="news__back">Zurück zur Website</a>
      </header>

      <main className="news__inner">
        <div className="aktuelles__header">
          <span className="aktuelles__label">Neuigkeiten</span>
          <h1 className="aktuelles__title">Aktuelles</h1>
          <div className="aktuelles__divider" />
        </div>

        {posts === null && (
          <p className="news__status">Beiträge werden geladen …</p>
        )}

        {posts && posts.length === 0 && (
          <p className="news__status">Derzeit gibt es keine Neuigkeiten.</p>
        )}

        {posts && posts.length > 0 && (
          <div className="aktuelles__grid">
            {posts.map((post) => (
              <PostCard key={post._id} post={post} />
            ))}
          </div>
        )}
      </main>

      <Footer onOpenLegal={setLegalModal} />
    </div>
  );
}

export default NewsPage;
